export default __webpack_public_path__ + "static/darkModeTalus-67215d08bf7b95524b1bdae3b71fb8cd.png";